<template lang="pug">
.dashboard-section
  .section-header
    .section-title
      h2 Pendientes como jefe
      p Solicitudes que necesitan revisión o aprobación.
  .cards-grid
    StatCard(
      v-for="item in lista"
      :key="item.id"
      :titulo="item.titulo"
      :descripcion="item.descripcion"
      :cantidad="item.cantidad"
      :tipo="item.tipo"
      :centrado="true"
      @click="redirigir(item.ruta)"
    )
</template>
<script>
import { apiGet, notify }  from '../../../util/general'
import StatCard from './c_statCard'
export default {
  name: 'PendientesJefe',
  components: {
    StatCard
  },
  data () {
    return {
      lista    : [
        {
          id: 1,
          titulo: 'Contratos por vencer',
          descripcion: 'Requieren revisión',
          cantidad: 0,
          tipo: 'danger',
          ruta: '/contratos-equipo'
        },
        {
          id: 2,
          titulo: 'Vacaciones sin aprobar',
          descripcion: 'Solicitudes pendientes',
          cantidad: 0,
          tipo: 'warning',
          ruta: '/vacaciones-equipo'
        },
        {
          id: 3,
          titulo: 'Permisos sin aprobar',
          descripcion: 'Solicitudes pendientes',
          cantidad: 0,
          tipo: 'info',
          ruta: '/permisos-equipo'
        }
      ],
      isLoading: true
    };
  },
  computed: {
    total () {
      return this.items.reduce((total, item) => {
        return total + item.cantidad
      }, 0)
    }
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      apiGet(vm, '/kpi/cantidad-contratos-vencer-jefe', {}, function (data) {
        vm.lista[0].cantidad = data.cantidad
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        apiGet(vm, '/kpi/cantidad-solicitudes-v-pendientes-aprobar', {}, function (data) {
          vm.lista[1].cantidad = data.cantidad
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          apiGet(vm, '/kpi/cantidad-permisos-sin-aprobar-jefe', {}, function (data) {
            vm.lista[2].cantidad = data.cantidad
          }, function (error) {
            console.error('error', error)
          }, function () {
            vm.isLoading = false
          })
        })
      })
    },
    redirigir (to) {
      this.$router.push(to)
    }
  }
}
</script>
<style scoped>
.dashboard-section {
  padding: 20px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 20px;
}
.section-header {
  margin-bottom: 17px;
}
.section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #292d32;
}
.section-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8b9097;
}
.section-counter {
  padding: 5px 10px;
  border-radius: 20px;
  background: #f8eeee;
  color: #b64242;
  font-size: 11px;
  font-weight: 600;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}
@media(max-width: 850px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// c_pendiente_jefe.vue?931cdf48